import { render } from "./Connection.vue?vue&type=template&id=0063f4e8"
import script from "./Connection.vue?vue&type=script&lang=js"
export * from "./Connection.vue?vue&type=script&lang=js"

import "./Connection.vue?vue&type=style&index=0&id=0063f4e8&lang=scss"

import exportComponent from "/app/tmp/ardia/V3/v2026.29.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__